import React, { useState, useEffect } from "react";
import Navbar from "./components/Navbar";
import { Link } from "react-router-dom";
import Footer from "./Footer";
import Heart from "react-heart";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { SkeletonCard } from "./components/SkeletonLoader";
import CarCard from "./components/CarCard";

const Favourites = () => {
  const optionToast = {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };
  const [favCars, setFavCars] = useState([]);
  const [likeStatus, setLikeStatus] = useState({});
  const [pageLoading, setPageLoading] = useState(true);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };
  const storedUserPreferences = getDataFromlocalStorage("userData");

  const filterCars = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/my-favorite-cars",
        {
          user_id: storedUserPreferences?.id,
        }
      );

      if (response?.data?.status) {
       const carsData=response?.data?.data;

        const initialLikeStatus = carsData.reduce((status, car) => {
          status[car?.cars?.id] = car?.isFav;
          return status;
        }, 
        {});
        
        setLikeStatus(initialLikeStatus);
        setFavCars(response?.data?.data);
        
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    filterCars();
  }, []);
  const likeDislike = async (user_id, card_id) => {
    try {
      const responsed = await axios.post(
        window.CARLOCA_API + "/like-dislike",
        {
          user_id: user_id,
          car_id: card_id,
        }
      );
      if (responsed?.data?.status) {
        filterCars();
        toast.success(responsed?.data?.message, optionToast);
      } else {
        toast.error(responsed?.data?.message, optionToast);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const handleLike = (cardId) => {
    if (storedUserPreferences !== null) {
      setLikeStatus((prevStatus) => ({
        ...prevStatus,
        [cardId]: !prevStatus[cardId],
      }));
      likeDislike(storedUserPreferences?.id, cardId);
    } else {
      toast.warning("Please login to add favorite car!", optionToast);
    }
  };
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between mb-3">
            <div>
              <h3 className="cl-page-title">Favourite Cars</h3>
              <p className="cl-page-subtitle">Cars you've saved for later</p>
            </div>
          </div>

          {pageLoading ? (
            <SkeletonCard count={8} />
          ) : favCars && favCars.length > 0 ? (
            <div className="row g-3">
              {favCars.map((car) => (
                <div
                  key={car.id}
                  className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                >
                  <CarCard
                    carData={car?.cars}
                    topLeftContent={
                      <div style={{ height: "24px", width: "24px" }}>
                        <Heart
                          isActive={likeStatus[car?.cars?.id]}
                          onClick={() => handleLike(car?.cars?.id)}
                          animationTrigger="both"
                          inactiveColor="rgba(255,255,255,0.9)"
                          activeColor="#00889C"
                          animationDuration={0.2}
                        />
                      </div>
                    }
                  />
                </div>
              ))}
            </div>
          ) : (
            <div className="cl-empty">
              <div className="cl-empty-icon"><i className="fa-solid fa-heart-crack"></i></div>
              <h6 className="cl-empty-title">No Saved Cars Yet</h6>
              <p className="cl-empty-text">Browse listings and tap the heart to save your favourites here.</p>
              <Link to="/FilterCarData" className="cl-btn cl-btn-primary"><i className="fa-solid fa-magnifying-glass me-2"></i>Browse Cars</Link>
            </div>
          )}
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Favourites;
